<template>
    <span v-html="convert(value)"></span>
</template>

<script>
export default {
    props: {
        value: Boolean,
    },
    methods: {
        convert(value) {
            return '<span class="label ' + (value ? 'bg-green' : 'bg-red') + '">' + (value ? 'Yes' : 'No') + '</span>';
        },
    },
};
</script>
